import {
    Component,
    OnDestroy,
    ViewChild,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatRadioButton, MatRadioModule } from '@angular/material/radio';
import { ICellRendererParams } from 'ag-grid-community';
import { FormCellRendererBaseComponent } from '../form-cell-renderer-base/form-cell-renderer-base.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-radio-button-cell-renderer',
    templateUrl: './radio-button-cell-renderer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatRadioModule],
})
export class RadioButtonCellRendererComponent
    extends FormCellRendererBaseComponent<ICellRendererParams>
    implements OnDestroy
{
    @ViewChild('inputElement') inputElement!: MatRadioButton;
    private readonly destroy$ = new Subject<void>();
    isChecked = false;

    agInit(params: ICellRendererParams): void {
        this.formControl = params.context.formControl;
        this.setParams(params);
        this.subscribeToFormControlChanges();
    }

    override refresh(params?: ICellRendererParams): boolean {
        if (params) {
            // Ensure formControl stays in sync with params.context during refresh
            this.formControl = params.context.formControl;
            this.setParams(params);
        }

        return true;
    }

    private setParams(params: ICellRendererParams): void {
        this.params = params;
        this.updateCheckedState();
    }

    private subscribeToFormControlChanges(): void {
        this.formControl.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.updateCheckedState());
    }

    private updateCheckedState(): void {
        this.isChecked = this.formControl.value === this.params.value;
    }

    onClick(): void {
        const isSameValue = this.formControl.value === this.params.value;
        this.formControl.setValue(isSameValue ? null : this.params.value);
    }

    onFocus(): void {
        if (this.shouldFocus()) {
            this.inputElement.focus();
            this.isFocusedState.set(true);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
